import React from "react";
import "./header.css";
import SearchIcon from "@mui/icons-material/Search";

const Header = () => {
  return (
    <div className="header">
      <img
        src="/LogoStridhaga-2.png"
        alt="Shridhaga Logo"
        className="header-logo"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "25px",
          marginRight: "12px",
        }}
      />
      {/* <div className="menu-icon">☰</div> */}

      <div className="header-title">
        <span className="running-title"> 𝚂𝚝𝚛𝚒𝚍𝚑𝚊𝚐𝚊 </span>
        {/* 𝙎𝙩𝙧𝙞𝙙𝙝𝙖𝙜𝙖 */}
        {/* 𝚂𝚝𝚛𝚒𝚍𝚑𝚊𝚐𝚊 */}
        {/* 𝕊𝕥𝕣𝕚𝕕𝕙𝕒𝕘𝕒 */}
      </div>

      <div className="header-right">
        {/* <input type="text" className="search-input" placeholder="Search" /> */}
        {/* <SearchIcon className="search-icon" /> */}

        <div className="sign-in-icon">S</div>
      </div>
    </div>
  );
};

export default Header;
